import { Backdrop, Box, Button, CircularProgress, TextField } from '@mui/material';
import { Formik } from 'formik';
import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as yup from 'yup';
import DataInfo from '../../components/DataInfoSimulations';
import HandlerDataInfos from '../../components/HandleDataInfo';
import { greenColor } from '../../config/colors';
import { useCookiesLogin } from '../../config/cookies';
import { handleSerasaScore } from './createConsulting';

import Header from '../../components/Header';
import { HOST_API } from '../../config/hosts';
import { useTranslation } from '../../hooks/useTranslation';
import ModalPendingConsult from '../../components/ModalPendingConsult';

const regexCPF = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
const regexCNPJ = /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/;

const initialValues = {
  cpf: '',
  amount: '',
};

const valuesSchema = yup.object().shape({
  amount: yup.number().required('Valor é obrigatório'),
  cpf: yup.string().required('CPF é obrigatório'),
});

const FormSerasa = ({ algorithm, installments, amount, simulationUri, title, noProposal }) => {
  const [brainAuth, setBrainAuth] = useState('');
  const [idConsult, setIdConsult] = useState('');
  const [cpf, setCpf] = useState('');
  const { cookies } = useCookiesLogin();
  const { id } = cookies.AUTH_TOKEN;

  const userID = cookies.AUTH_TOKEN.id;

  const [dataInfo, setDataInfo] = useState(false);
  const [isClient, setIsClient] = useState(false);
  const [handleRefresh, setHandleRefresh] = useState(false);
  const [clientId, setClientId] = useState('');
  const [bussinesId, setBussinesId] = useState('');

  const [isLoading, setIsLoading] = useState(false);
  const [showPendingModal, setShowPendingModal] = useState(false);
  const [pendingOrderData, setPendingOrderData] = useState(null);
  const { t } = useTranslation();

  const handleWaitForResult = () => {
    setShowPendingModal(false);
    setDataInfo(true);
    setIsClient(false);
    setCpf(pendingOrderData?.consult?.document || '');
    setIdConsult(pendingOrderData?.id || pendingOrderData?._id || '');
    setBrainAuth(cookies.AUTH_TOKEN.token);
    setHandleRefresh(true);
    setPendingOrderData(null);
  };

  const handleNewConsult = () => {
    setShowPendingModal(false);
    setPendingOrderData(null);
  };

  const verificationCPFCNPJAndAmount = (cpf) => {
    return cpf.replace(/\D/g, '').length === 0;
  };

  useEffect(() => {
    console.log('Atualizando');
  }, [handleRefresh]);

  return (
    <Box mt={10}>
      <ToastContainer />
      <Header
        title={`REDSCORE`}
        subtitle="Análises de crédito realizadas pela equipe especializada do Reduto Score."
      />
      <Formik initialValues={initialValues} validationSchema={valuesSchema}>
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
          <form
            onSubmit={async (event) => {
              setIsLoading(true);
              handleSubmit(event);

              if (verificationCPFCNPJAndAmount(values.cpf)) {
                toast.info(t('messages.cpfCnpjCannotBeEmpty'), {
                  theme: 'dark',
                });
                setIsLoading(false);
              }

              const { token } = cookies.AUTH_TOKEN;

              const response = await fetch(`${HOST_API}/v1/order/create`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({
                  taxvar: values.cpf.replace(/\D/g, ''),
                }),
              });

              const data = await response.json();

              if (response.ok) {
                const stage = data?.data?.stage;

                if (data?.fromCache && (stage === 'PENDING' || stage === 'CREATED')) {
                  setPendingOrderData(data.data);
                  setShowPendingModal(true);
                  setIsLoading(false);
                  return;
                }


                setDataInfo(true);
                setIsClient(false);
                setCpf(values.cpf.replace(/\D/g, ''));
                setIdConsult(data._id || data.id);
                setBrainAuth(token);
                setHandleRefresh(true);
              } else {
                toast.error(t('messages.consultError'));
              }

              setIsLoading(false);
            }}
          >
            <Box display="grid" gap="30px" gridTemplateColumns="repeat(4, minmax(0, 1fr))">
              <TextField
                fullWidth
                variant="filled"
                label={t('forms.cpfCnpj')}
                type="text"
                color="secondary"
                value={
                  values.cpf.length === 11
                    ? values.cpf.replace(regexCPF, '$1.$2.$3-$4')
                    : values.cpf.replace(regexCNPJ, '$1.$2.$3/$4-$5')
                }
                onChange={handleChange}
                handleBlur={handleBlur}
                inputProps={{ maxLength: 22 }}
                sx={{ gridColumn: 'span 2' }}
                name="cpf"
                error={!!touched.cpf && !!errors.cpf}
                helperText={touched.cpf && errors.cpf}
              />
              <Box>
                {handleRefresh === true ? (
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    {t('buttons.newConsult')}
                  </Button>
                ) : (
                  <Button type="submit" color="secondary" variant="contained">
                    {t('buttons.consultClient')}
                  </Button>
                )}
              </Box>
            </Box>
          </form>
        )}
      </Formik>
      {/* COMPONENTE PARA ESPERAR O WEBHOOK BRAIN */}
      {dataInfo === true && isClient === false ? (
        <>
          <DataInfo
            algorithm={algorithm}
            amount={amount}
            clientId={userID}
            cpf={cpf}
            idConsult={idConsult}
            isClient={isClient}
            tokenSerasa={brainAuth}
            userId={id}
            key={userID}
            installments={installments}
            simulationUri={simulationUri}
            title={title}
            noProposal={noProposal}
          />
        </>
      ) : null}

      {/* COMPONENTE RETORNA DIRETO O ID CADASTRADO NA BASE DE DADOS */}
      {dataInfo === false && isClient === true ? (
        <>
          <HandlerDataInfos
            cpfcnpj={cpf}
            idConsult={idConsult}
            tokenBrain={brainAuth}
            algorithm={algorithm}
            isClient={isClient}
            amount={amount}
            clientId={userID}
            installments={installments}
            simulationUri={simulationUri}
            title={title}
            noProposal={noProposal}
          />
        </>
      ) : null}

      {isLoading === true ? (
        <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" sx={{ color: greenColor }} />
        </Backdrop>
      ) : null}

      <ModalPendingConsult
        open={showPendingModal}
        onWait={handleWaitForResult}
        onNewConsult={handleNewConsult}
      />
    </Box>
  );
};

export default FormSerasa;
